import { render, staticRenderFns } from "./AiModelSettings.vue?vue&type=template&id=5a587956"
import script from "./AiModelSettings.vue?vue&type=script&lang=js"
export * from "./AiModelSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports